function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { get, forIn, unset } from 'lodash';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import * as selectors from '../../../../selectors';
import { SIGN_UP_FORM, SCOPE_NAMES, ANONYMOUS_LAST_NAME, ANONYMOUS_FIRST_NAME } from '../../../../constants';
import { pickLegalConsents } from '../../helpers';
export const useFormatFormValuesForSubmit = ()=>{
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const langCode = useSelector(App.selectors.langCode);
    const invitationToken = useSelector(selectors.invitationToken);
    return useCallback((validatedValues)=>{
        const values = get(formValues, 'values');
        const valuesToSubmit = _object_spread({}, values, validatedValues);
        valuesToSubmit.accountSource = 'Aid';
        valuesToSubmit.language = langCode;
        const legalConsents = pickLegalConsents(valuesToSubmit);
        const legalConsentApprovals = [];
        forIn(legalConsents, (value, key)=>{
            const id = parseInt(key.split('-')[1], 10);
            legalConsentApprovals.push({
                legalConsentId: id,
                decision: value
            });
            unset(valuesToSubmit, `legalConsent-${id}`);
        });
        valuesToSubmit.legalConsentApprovals = legalConsentApprovals;
        if (valuesToSubmit.scope === SCOPE_NAMES.PERSONAL) {
            if (!valuesToSubmit.firstName) valuesToSubmit.firstName = ANONYMOUS_FIRST_NAME;
            if (!valuesToSubmit.lastName) valuesToSubmit.lastName = ANONYMOUS_LAST_NAME;
        }
        if (valuesToSubmit.dateOfBirth) {
            valuesToSubmit.dateOfBirth = values.dateOfBirthAsDateFormat;
            unset(valuesToSubmit, 'dateOfBirthAsDateFormat');
        }
        if (valuesToSubmit.appSKUCountryCode) {
            valuesToSubmit.countrySelectedUponRegistration = valuesToSubmit.countryCode;
            valuesToSubmit.countryCode = valuesToSubmit.appSKUCountryCode;
            unset(valuesToSubmit, 'appSKUCountryCode');
        }
        if (invitationToken) valuesToSubmit.invitationToken = invitationToken;
        return valuesToSubmit;
    }, [
        formValues,
        langCode,
        invitationToken
    ]);
};
